/* global yupeTokenName */
/* global yupeToken */
/* global ga */
/* global ymaps */
/* global VK */
/* global gtag */
/* global Ya */
import Cleave from 'cleave.js';
import { tns } from 'tiny-slider/src/tiny-slider';

require('cleave.js/dist/addons/cleave-phone.ru');
require('suggestions-jquery');

function updateCartWidget() {
    const shoppingCartWidget = $('#shopping-cart-widget');
    $.ajax({
        type: 'get',
        url: '/cart/widget',
        dataType: 'html',
    }).done((res) => {
        shoppingCartWidget.html(res);
    }).fail(() => {
        // eslint-disable-next-line no-console
        console.error('Couldnt update cart widget');
    });
}

function priceFormat(val) {
    return val.toFixed(0).replace(/./g, (c, i, a) => (i && c !== '.' && ((a.length - i) % 3 === 0) ? `&nbsp;${c}` : c));
}

function redrawCartList() {
    let fullSumm = 0;
    let fullSummDelivery = 0;

    const deliverySelected = $('.js-cart-order-type:checked');
    const deliveryPrice = parseFloat(deliverySelected.data('price'), 10);
    const deliveryFreeFrom = parseFloat(deliverySelected.data('freeFrom'), 10);
    const selectedDelivery = parseInt(deliverySelected.val(), 10);

    $('.js-cart-list-item').each((index, element) => {
        const row = $(element);
        const itemQty = parseInt($('.js-cart-qty-val', row).val(), 10);
        const qtyText = $('.js-cart-qty-text', row);
        const minusButton = $('[data-toggle="cartListChangeQtyForProduct"][data-operator="-"]', row);

        if (!row.attr('data-position-price')) {
            throw new Error('data-position-price is undefined in row');
        }

        const itemPrice = parseFloat(row.data('position-price'), 10);
        if (itemPrice < 0) {
            throw new Error('data-position-price меньше нуля!');
        }

        minusButton.toggleClass('disabled', (itemQty === 1));
        qtyText.text(itemQty);

        const productDataLayer = row.data('dataLayer');
        productDataLayer.quantity = itemQty;
        row.data('dataLayer', productDataLayer);

        const itemSumm = (itemPrice * itemQty);
        $('.js-cart-item-summ', row).html(priceFormat(itemSumm));

        fullSumm += itemSumm;
        row.removeClass('loading');
    });

    fullSummDelivery = fullSumm;
    if (deliverySelected.data('freeFrom')) {
        if (deliveryFreeFrom > fullSummDelivery) {
            fullSummDelivery += deliveryPrice;
        }
    } else {
        fullSummDelivery += deliveryPrice;
    }

    $('.js-cart-summ-value').html(priceFormat(fullSumm));
    if (selectedDelivery === 3 || selectedDelivery === 4) {
        $('.js-cart-summ-delivery-value').closest('div').html('<span class="js-cart-summ-delivery-value">Доставка рассчитывается отдельно!</span>');
    } else if (selectedDelivery === 5) {
        $('.js-cart-summ-delivery-value').closest('div').html(`<span class="js-cart-summ-delivery-value">Итого с учетом самовывоза: <nobr>${priceFormat(fullSummDelivery)} руб.</nobr></span>`);
    } else {
        $('.js-cart-summ-delivery-value').closest('div').html(`Итого с учетом доставки: <nobr><span class="js-cart-summ-delivery-value">${priceFormat(fullSummDelivery)}</span>&nbsp;руб.</nobr>`);
    }


    $('.js-cart-order-type').each((index, elem) => {
        const deliveryItem = $(elem).closest('.cart__order__delivery__radio__item');
        const availableFrom = parseFloat($(elem).data('availableFrom'), 10);
        const availableFromText = $('.cart__order__delivery__radio__item__availablefrom', deliveryItem);
        if (fullSumm > availableFrom) {
            $(elem).prop('disabled', false);
            availableFromText.hide();
            deliveryItem.removeAttr('data-toggle')
                .removeAttr('data-placement')
                .removeAttr('data-trigger')
                .removeAttr('title')
                .tooltip('dispose');
        } else {
            $(elem).prop('disabled', (fullSumm < availableFrom));
            availableFromText.show();
            deliveryItem.attr('data-toggle', 'tooltip');
            deliveryItem.attr('data-placement', 'bottom');
            deliveryItem.attr('data-trigger', 'click hover focus');
            deliveryItem.attr('title', availableFromText.text());
            deliveryItem.tooltip();
        }

        const freeFromData = $(elem).data('freeFrom');
        if (freeFromData) {
            const freeFrom = parseFloat(freeFromData, 10);
            const freeFromText = $('.cart__order__delivery__radio__item__price', deliveryItem);
            const freeFromSlogan = $('.cart__order__delivery__radio__item__slogan', deliveryItem);
            const freeFromSloganPrice = $('.js-slogan-price', deliveryItem);

            if (fullSumm >= freeFrom) {
                freeFromText.hide();
                freeFromSlogan.hide();
                freeFromSloganPrice.html(priceFormat(freeFrom - fullSumm));
            } else {
                freeFromText.show();
                freeFromSlogan.show();
                freeFromSloganPrice.html(priceFormat(freeFrom - fullSumm));
            }
        }
    });
}

function changePositionQuantity(productId, qty) {
    const data = {
        quantity: qty,
        id: productId,
    };
    data[yupeTokenName] = yupeToken;
    $.ajax({
        url: '/cart/update',
        type: 'post',
        dataType: 'json',
        data,
    }).done((res) => {
        if (res.result) {
            updateCartWidget();
            redrawCartList();
        }
    });
}

function cartListQTYField() {
    $('[data-toggle="cartListChangeQtyForProduct"]').on('click', (event) => {
        const elem = $(event.currentTarget);

        if (elem.hasClass('disabled')) {
            event.preventDefault();
            return;
        }

        const row = elem.closest('.js-cart-list-item');
        const operator = elem.data('operator');
        const QTYhiddenField = $('.js-cart-qty-val', row);
        const QTYhiddenFieldVal = parseInt(QTYhiddenField.val(), 10);

        if (row.hasClass('loading')) {
            event.preventDefault();
            return;
        }

        const operators = {
            '+': (a) => a + 1,
            '-': (a) => ((a > 1) ? a - 1 : a),
        };

        const newVal = operators[operator](QTYhiddenFieldVal);

        row.addClass('loading');
        QTYhiddenField.val(newVal);

        changePositionQuantity(row.data('position-id'), newVal);
    });
}

function initOrder() {
    $('#add-coupon-code').click((event) => {
        event.preventDefault();
        const code = $('#coupon-code').val();
        if (code) {
            const data = {
                code,
            };
            data[yupeTokenName] = yupeToken;
            $.ajax({
                url: '/coupon/add',
                type: 'post',
                data,
                dataType: 'json',
                success(res) {
                    if (res.result) {
                        window.location.reload();
                    }
                },
            });
            $('#coupon-code').val('');
        }
    });

    $('.coupon .close').click((event) => {
        event.preventDefault();
        const code = $(event.currentTarget).siblings('input[type="hidden"]').data('code');
        const data = {
            code,
        };
        const el = $(event.currentTarget).closest('.coupon');
        data[yupeTokenName] = yupeToken;
        $.ajax({
            url: '/coupon/remove',
            type: 'post',
            data,
            dataType: 'json',
            success(res) {
                if (res.result) {
                    el.remove();
                }
            },
        });
    });

    $('#coupon-code').keypress((event) => {
        if (event.which === 13) {
            event.preventDefault();
            $('#add-coupon-code').click();
        }
    });

    $('.order-form').submit((event) => {
        $(event.currentTarget).find("button[type='submit']").prop('disabled', true);
    });

    const defs = {
        token: '352efb5d0ffe0c94de822d9716066728d2d84995',
        type: 'ADDRESS',
        hint: false,
    };

    if ($.fn.suggestions) {
        $('#Order_city').suggestions($.extend({}, defs, {
            bounds: 'city-settlement',
            // formatResult: function(value, currentValue, suggestion){
            //     var re = new RegExp('(\\s|^)' + suggestion.data.region_type + '(\\s|$)', 'g');
            //     return suggestion.value.replace(re, ' ' + suggestion.data.region_type_full + ' ').trim()
            // },
            // formatSelected: function(value, currentValue, suggestion){
            //     var re = new RegExp('(\\s|^)' + suggestion.data.region_type + '(\\s|$)', 'g');
            //     return suggestion.value.replace(re, ' ' + suggestion.data.region_type_full + ' ').trim()
            // },
        }));
        $('#Order_street').suggestions($.extend({}, defs, {
            bounds: 'street',
            constraints: $('#Order_city'),
            // formatResult: function(value, currentValue, suggestion){
            //     var re = new RegExp('(\\s|^)' + suggestion.data.region_type + '(\\s|$)', 'g');
            //     return suggestion.value.replace(re, ' ' + suggestion.data.region_type_full + ' ').trim()
            // },
            // formatSelected: function(value, currentValue, suggestion){
            //     var re = new RegExp('(\\s|^)' + suggestion.data.region_type + '(\\s|$)', 'g');
            //     return suggestion.value.replace(re, ' ' + suggestion.data.region_type_full + ' ').trim()
            // },
        }));
        $('#Order_house').suggestions($.extend({}, defs, {
            bounds: 'house',
            constraints: $('#Order_street'),
        }));
    }

    $('.js-cart-order-type').on('change', () => {
        const checked = $('.js-cart-order-type:checked');
        const checkedText = $.trim($('.js-cart-order-type:checked').closest('.form-check').find('.cart__order__delivery__radio__item__name').text());

        try {
            gtag('event', 'set_checkout_option', {
                checkout_step: 1,
                checkout_option: 'shipping method',
                value: checkedText,
            });
        } catch (error) {}

        $('.js-cart-delivery-description').hide();
        $(`.js-cart-delivery-description#${checked.data('descriptionId')}`).show();

        redrawCartList();

        //
        const checkedVal = parseInt(checked.val(), 10);

        if (checkedVal === 1 || checkedVal === 2 || checkedVal === 5) {
            $('.js-cart-payments-block').show();
        } else {
            $('.js-cart-payments-block').hide();
        }

        if (checkedVal === 5) {
            $('.js-cart-fields-hide-on-pickup').hide();
            $('.js-cart-fields-hide-on-pickup').find('.js-required-when-visible').prop('required', false).prop('disabled', true);
        } else {
            $('.js-cart-fields-hide-on-pickup').show();
            $('.js-cart-fields-hide-on-pickup').find('.js-required-when-visible').prop('required', true).prop('disabled', false);
        }
    }).trigger('change');
}

function initPromocode() {
    $('.js-promocode-button').click((event) => {
        event.preventDefault();
        const promocode = $('.js-promocode-field').val();
        const data = {
            promocode,
        };
        data[yupeTokenName] = yupeToken;
        $.ajax({
            url: '/cart/promocode',
            type: 'post',
            data,
            dataType: 'json',
            success(res) {
                if (res.data === 'ok') {
                    window.location.reload();
                }
            },
        });
        $('.js-promocode-field').val('');
    });
}

function initAdd2cart() {
    const successModal = $('#modal-add2cart-success');

    $(document).on('click', '.js-add-to-cart', (event) => {
        const elem = $(event.currentTarget);
        const data = {
            'Product[id]': elem.data('product-id'),
        };
        const productDataLayer = elem.data('dataLayer');

        if (elem.data('productVariant')) {
            data.ProductVariant = [];
            data.ProductVariant.push(elem.data('productVariant'));
        }
        data[yupeTokenName] = yupeToken;

        $.ajax({
            url: '/cart/add',
            type: 'post',
            dataType: 'json',
            data,
        }).done((res) => {
            if (res.result) {
                event.preventDefault();
                updateCartWidget();

                if (productDataLayer) {
                    productDataLayer.quantity = 1;
                    gtag('event', 'add_to_cart', {
                        items: [
                            productDataLayer,
                        ],
                    });

                    $('.js-modal-add2cart-success-productname').text(productDataLayer.name);
                    try {
                        ga('ec:addProduct', productDataLayer);
                        ga('ec:setAction', 'add');
                    } catch (e) {
                        // eslint-disable-next-line no-console
                        console.error('Error: no ga found');
                    }
                }
                successModal.modal('show');
            }
        });
    });
}

function cartListDeleteProduct() {
    $(document).on('click', '.js-cart-item-delete-modal', (event) => {
        event.preventDefault();

        const row = $(event.currentTarget).closest('.js-cart-list-item');
        const modal = $('#modal-removefromcart');

        if (row.hasClass('loading')) {
            return;
        }

        $('.js-modal-removefromcart-text', modal).html(`Вы действительно хотите удалить «${row.data('positionName')}» из корзины?`);
        $('.js-cart-item-delete', modal).attr('data-position-id', row.data('position-id'));

        modal.modal('show');
    });

    $(document).on('click', '.js-cart-item-delete', (event) => {
        event.preventDefault();
        const id = $(event.currentTarget).data('position-id');
        const row = $(`.js-cart-list-item[data-position-id="${id}"]`);
        const data = {
            id,
        };
        data[yupeTokenName] = yupeToken;

        $.ajax({
            url: '/cart/delete',
            type: 'post',
            dataType: 'json',
            data,
            success(res) {
                if (res.result) {
                    // const productDataLayer = row.data('dataLayer');
                    // if (productDataLayer) {
                    //     const remove = {
                    //         ecommerce: {
                    //             remove: {
                    //                 products: [
                    //                     productDataLayer,
                    //                 ],
                    //             },
                    //         },
                    //     };
                    //     dataLayer.push(remove);
                    // }

                    row.remove();
                    const modal = $('#modal-removefromcart');
                    modal.modal('hide');

                    updateCartWidget();
                    redrawCartList();

                    if ($('.js-cart-list-item').length === 0) {
                        window.location.reload();
                    }
                }
            },
        });
    });
}

function initModalCallback() {
    const modalCallback = $('#modal-callback');
    const modalCallbackForm = $('#callback-form', modalCallback);

    modalCallback.on('show.bs.modal', (event) => {
        const button = $(event.relatedTarget);
        const modalTitle = button.data('setTitle') || 'Обратный звонок';
        const modalButton = button.data('setButton') || 'Перезвоните мне!';
        const modalComment = button.data('setComment') || '';
        const modal = $(event.currentTarget);
        modal.find('.modal-title').text(modalTitle);
        modal.find('.js-callback-comment').val(modalComment).attr('value', modalComment);
        modal.find('.js-callback-normal').html(`${modalButton}&nbsp;<i class="fas fa-angle-right fa-fw"></i>`);
    }).on('shown.bs.modal', (event) => {
        $('.contactus__backdrop').trigger('click');
        $(event.currentTarget).find('[data-autofocus="autofocus"]').focus();
    });

    // eslint-disable-next-line no-new
    new Cleave('[autocomplete="tel"]', {
        prefix: '+7 (',
        delimiters: [')', '-', '-'],
        blocks: [7, 3, 2, 2],
        uppercase: true,
    });

    const fields = $('.js-callback-fields');
    const result = $('.js-callback-result');
    const captchaValue = $('#js-callback-captcha-value', modalCallbackForm);
    const submitBtn = $(':submit', modalCallbackForm);
    const submitBtnNormal = $('.js-callback-normal');
    const submitBtnLoading = $('.js-callback-loading');
    modalCallbackForm.on('submit', (event) => {
        event.preventDefault();

        submitBtn.attr('disabled', true);
        submitBtnNormal.hide();
        submitBtnLoading.show();

        try {
            grecaptcha.enterprise.ready(async () => {
                const token = await grecaptcha.enterprise.execute('6LeHaUspAAAAAKpfmUVgDUw6BYTddKRiASZEZZxy', { action: 'CALLBACK' });
                captchaValue.val(token);

                $.ajax({
                    url: modalCallbackForm.attr('action'),
                    type: modalCallbackForm.attr('method'),
                    data: modalCallbackForm.serialize(),
                }).done((response) => {
                    if (response.result) {
                        result.find('.h2').html('Спасибо!');
                        result.find('p').html('Мы перезвоним Вам в ближайшее время!');
                        document.getElementById('callback-form').reset();
                    } else {
                        result.find('.h2').html('Извините!');
                        result.find('p').html('К сожалению не удалось отправить заявку на обратный звонок. Мы уже работаем над решением этой проблемы. Наш телефон для связи: <a href="tel:+74993918019">+7 (499) 391-80-19</a>');
                    }
                    fields.hide();
                    result.show();
                    submitBtn.removeAttr('disabled');
                    submitBtnNormal.show();
                    submitBtnLoading.hide();
                });
            });
        } catch (error) {
            console.error(error);
        }

        return false;
    });
    $('.js-callback-result-close').on('click', (event) => {
        event.preventDefault();
        fields.show();
        result.hide();
        submitBtn.removeAttr('disabled');
        submitBtnNormal.show();
        submitBtnLoading.hide();
    });
}

window.ymapsonload = () => {
    const ways = {
        wayPedestrian() {
            window.map.geoObjects.removeAll();
            window.multiRoute = new ymaps.multiRouter.MultiRoute({
                referencePoints: [
                    'Москва, метро Пражская, 2 выход',
                    [55.60955753229176, 37.615418721563714],
                    [55.60967174487069, 37.61473255753445],
                    window.pointB,
                ],
                params: {
                    routingMode: 'pedestrian',
                },
            }, {
                wayPointVisible: false,
                routeActiveMarkerVisible: false,
                routeOpenBalloonOnClick: false,
                boundsAutoApply: true,
            });

            // multiRoute.editor.start({
            //     addWayPoints: true,
            //     removeWayPoints: true
            // });

            window.map.geoObjects.add(window.pointB).add(window.multiRoute);
        },
        wayCar() {
            window.map.geoObjects.removeAll();
            window.multiRoute = new ymaps.multiRouter.MultiRoute({
                referencePoints: [
                    [55.61306805825558, 37.61034845353013],
                    // [55.60955753229176, 37.615418721563714],
                    // [55.60967174487069, 37.61473255753445],
                    [55.60935408789969, 37.615306068786225],
                ],
                params: {
                    // routingMode: 'pedestrian'
                },
            }, {
                wayPointVisible: false,
                routeActiveMarkerVisible: false,
                routeOpenBalloonOnClick: false,
                boundsAutoApply: true,
            });

            // multiRoute.editor.start({
            //     addWayPoints: true,
            //     removeWayPoints: true
            // });

            window.map.geoObjects.add(window.pointB).add(window.multiRoute);
        },
    };

    ymaps.ready(() => {
        if ($('#contact_us_map').length) {
            window.map = new ymaps.Map('contact_us_map', {
                center: [55.61026100966122, 37.60977549999999],
                zoom: 15.5,
                controls: [],
            });

            if (window.map) {
                $('a[data-toggle="list"]').on('shown.bs.tab', (event) => {
                    window.map.container.fitToViewport();
                    const setRoute = $(event.target).data('setRoute');
                    ways[setRoute]();
                });

                window.pointB = new ymaps.Placemark([55.609846, 37.614834], {
                    balloonContentHeader: 'Пункт самовывоза',
                    balloonContent: '<strong>Mountain-Rock.ru</strong><br>ул.&nbsp;Подольских курсантов, д.&nbsp;3, стр.&nbsp;7',
                    balloonContentFooter: 'ВНИМАНИЕ! В пункте самовывоза находится только предварительно забронированный товар.',
                    hintContent: 'Пункт самовывоза Mountain-Rock.ru',
                }, {
                    iconColor: '#0450b1',
                });

                ways.wayPedestrian();
            }
        }
    });
};

function initContactUs() {
    if (!$('#contact_us_map').length) {
        return;
    }

    const e = document.createElement('script');
    const f = document.getElementsByTagName('script')[0];

    e.async = true;
    e.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=3cd5d586-6560-42fe-a387-74906dfc84b2&onload=ymapsonload';
    f.parentNode.insertBefore(e, f);
}

function initVk() {
    const e = document.createElement('script');
    const f = document.getElementsByTagName('script')[0];

    e.async = true;
    e.src = 'https://vk.com/js/api/openapi.js?161';
    e.addEventListener('load', window.vkwidgetinit, false);

    f.parentNode.insertBefore(e, f);
}

window.vkwidgetinit = () => {
    window.addEventListener('load', window.vkwidgetinit, false);
    window.addEventListener('resize', window.vkwidgetinit, false);
    $('#navbarToggler').on('shown.bs.collapse', window.vkwidgetinit);

    document.getElementById('vk_groups').innerHTML = '';
    document.getElementById('vk_groups').style = '';
    try {
        VK.Widgets.Group('vk_groups', {
            mode: 3,
            wide: 1,
            width: 'auto',
            height: 183,
        }, 25727391);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
};

function initShowpromocode() {
    const modalId = 'modal-promocode';
    const modal = $(`#${modalId}`);
    if (!modal.length) {
        return;
    }

    const modalPromocode = `modal_${modal.data('promocode')}`;

    if (typeof Storage !== 'undefined') {
        if (sessionStorage.getItem(modalPromocode) !== 'true') {
            setTimeout(() => {
                modal.modal('show');
                sessionStorage.setItem(modalPromocode, 'true');
            }, 2401);
        }
    }


    $('.js-copy-promocode-init', modal).on('click', (event) => {
        event.preventDefault();
        const promoField = $('#js-copy-promocode', modal);

        const el = promoField.get(0);

        const oldContentEditable = el.contentEditable;
        const oldReadOnly = el.readOnly;
        const range = document.createRange();

        el.contenteditable = true;
        el.readonly = false;
        range.selectNodeContents(el);

        const s = window.getSelection();
        s.removeAllRanges();
        s.addRange(range);

        el.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

        if (document.execCommand('copy')) {
            promoField.closest('.input-group').tooltip('show');
            setTimeout(() => {
                promoField.closest('.input-group').tooltip('hide');
            }, 1500);
        } else {
            promoField.closest('.input-group').tooltip('show');
            setTimeout(() => {
                promoField.closest('.input-group').tooltip('hide');
            }, 3500);
        }

        el.contentEditable = oldContentEditable;
        el.readOnly = oldReadOnly;

        // el.select();
        // document.execCommand('copy');
    });
}

function initProductVariant() {
    if (!$('.js-product-variant').length) {
        return;
    }
    const updateCheckedVariant = () => {
        const checked = $('.js-product-variant:checked');

        const type = parseInt(checked.data('optionType'), 10);
        const amount = parseInt(checked.data('optionAmount'), 10);
        const basePrice = parseInt($('#base-price').val(), 10);
        const shownPrice = $('.js-shown-price');
        let newPrice = 0;

        switch (type) {
        case 0:
            // Увеличить на сумму
            newPrice = basePrice + amount;
            break;
        case 1:
            // Увеличить на %
            newPrice = basePrice + basePrice * (amount / 100);
            break;
        case 2:
            // Изменение базовой цены
            newPrice = amount;
            break;
        default:
            newPrice = 0;
            break;
        }

        shownPrice.html(priceFormat(newPrice));
        $('.js-add-to-cart').attr('data-product-variant', checked.val());
    };
    if (!$('.js-product-variant:checked').length) {
        $('.js-product-variant').first().prop('checked', true).parent('.btn')
            .addClass('active');
        updateCheckedVariant();
    }
    $('.js-product-variant').on('change', () => {
        updateCheckedVariant();
    }).trigger('change');
}

$(document).ready(() => {
    $('[data-fancybox]').fancybox();
    $('[data-toggle="popover"]').popover();
    $('[data-toggle="tooltip"]').tooltip();

    const carousel = {
        brands: {
            container: '.js-brands-carousel',
            items: 3,
            center: true,
            nav: false,
            controls: false,
            slideBy: 1,
            mouseDrag: true,
            autoplay: true,
            autoplayButton: false,
            autoplayButtonOutput: false,
            gutter: 10,
            edgePadding: 15,
            responsive: {
                540: {
                    items: 3,
                    center: true,
                },
                720: {
                    items: 4,
                    center: false,
                },
                960: {
                    items: 6,
                    center: false,
                },
                1140: {
                    items: 8,
                    center: false,
                },
            },
        },
        cards: {
            container: '.js-viewed-carousel',
            items: 1,
            center: true,
            nav: false,
            controls: false,
            slideBy: 1,
            mouseDrag: true,
            autoplay: true,
            autoplayButton: false,
            autoplayButtonOutput: false,
            gutter: 10,
            edgePadding: 15,
            responsive: {
                540: {
                    items: 3,
                    center: true,
                },
                720: {
                    items: 2,
                    center: false,
                },
                960: {
                    items: 3,
                    center: false,
                },
                1140: {
                    items: 4,
                    center: false,
                },
            },
        },
        popular: {
            container: '.js-popular-carousel',
            items: 1,
            center: true,
            nav: false,
            controls: false,
            slideBy: 1,
            mouseDrag: true,
            autoplay: true,
            autoplayButton: false,
            autoplayButtonOutput: false,
            edgePadding: 15,
            responsive: {
                540: {
                    items: 3,
                    center: true,
                },
                720: {
                    items: 2,
                    center: false,
                },
                960: {
                    items: 3,
                    center: false,
                },
                1140: {
                    items: 5,
                    center: false,
                },
            },
        },
    };

    Object.entries(carousel).forEach(([key, value]) => {
        if (document.querySelector(value.container)) {
            tns(value);
        }
    });

    // $('.catalognav__menu > .catalognav__menu__item > a').on('click', (event) => {
    //     const item = $(event.currentTarget).closest('.catalognav__menu__item');
    //     if (item.find('.catalognav__menu__item__submenu').length && !item.hasClass('catalognav__menu__item--active')) {
    //         event.preventDefault();
    //         item.addClass('catalognav__menu__item--active').siblings('.catalognav__menu__item').removeClass('catalognav__menu__item--active');
    //     }
    // });

    $('.js-scrollto').on('click', (event) => {
        event.preventDefault();
        const target = $(event.currentTarget).attr('href');
        if (document.querySelector(target)) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(target).offset().top,
            }, 1000);
        }
    });

    $('.salepopup-close').on('click', (event) => {
        event.preventDefault();
        $('.salepopup-toggle').toggleClass('salepopup-toggle--active');
        $('.salepopup').toggleClass('salepopup--active');
    });

    $('.salepopup-toggle').on('click', (event) => {
        event.preventDefault();
        $('.salepopup-toggle').toggleClass('salepopup-toggle--active');
        $('.salepopup').toggleClass('salepopup--active');
    });

    initOrder();
    initAdd2cart();
    initPromocode();
    cartListQTYField();
    cartListDeleteProduct();
    redrawCartList();
    initModalCallback();
    initContactUs();
    initShowpromocode();
    initProductVariant();

    // VK pixel
    setTimeout(() => {
        initVk();

        const n = document.getElementsByTagName('script')[0];
        const s = document.createElement('script');
        s.async = true;
        s.src = 'https://chat.s3.yandex.net/widget.js';
        n.parentNode.insertBefore(s, n);

        (window.Image ? (new Image()) : document.createElement('img')).src = 'https://vk.com/rtrg?p=VK-RTRG-141924-2Oc4T';
    }, 4000);

    /* eslint-disable */
    (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

    window.ym(17684812, 'init', {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
        trackHash: true,
        ecommerce: 'dataLayer',
    });
    /* eslint-enable */
});
